import {ModalController} from '../common/modal.controller.js';

class PacijentController {
    constructor($uibModal, Pacijent, $state) {
        this.$uibModal = $uibModal;
        this.ModelFactory = Pacijent;
        this.$state = $state;
        this.items = [];
        this.pager = {
            currentPage: 1,
            limit: 15,
            totalItems: 0,
            search: "",
        };

        this.refreshState();
    }

    refreshState(){
        this.getItems();
    }

    insert() {
        const model = {};
        const modal = this.$uibModal.open({
            template: '<pacijent-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pacijent-form>',
            controller: ModalController,
            controllerAs: 'vm',
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    edit(item) {
        const model = item;
        const modal = this.$uibModal.open({
            template: '<pacijent-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pacijent-form>',
            controller: ModalController,
            controllerAs: 'vm',
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    delete(item) {
        const previousWindowKeyDown = window.onkeydown;
        swal({
            title: "Brisanje pacijenta",
            text: `Za potvrdu brisanja pacijenta ${item.prezime} ${item.ime} upišite 'da'`,
            type: "input",
            showCancelButton: true,
            closeOnConfirm: false,
        },(inputValue) => {
            window.onkeydown = previousWindowKeyDown;
            if (inputValue === false) return false;
            if (inputValue === 'da') {
                this.ModelFactory.destroy(item.id).then(
                    (data) => {
                        this.refreshState();
                        swal("Pacijent obrisan", `Pacijent ${item.prezime} ${item.ime} uspiješno je obrisan`, "success");
                    },
                    (error) => {
                        swal("Greška", `Došlo je do greške prilikom brisanja pacijenta ${item.prezime} ${item.ime}  `, "error");
                    });
                return true;
            }
            swal.showInputError("Nedozvoljena vrijednost");
            return false;
        });
    }

    details(item) {
        this.$state.go('pacijent.detail', {id:item.id});
    }

    getItems() {
        const params = {
            limit: this.pager.limit,
            offset: 0,
            ordering: 'naziv',
            search: this.pager.search,
        };

        if (params.search === '') {
            delete (params.search);
        }

        params.offset = (this.pager.currentPage - 1) * params.limit;

        this.ModelFactory.findAll(params, {bypassCache: true}).then((response) => {
            this.items = response;
            if (angular.isDefined(response.meta)) {
                this.pager.totalItems = response.meta.count;
            }
        });
    }

    onFilter(value) {
        this.pager.search = value;
        this.refreshState();
    }

    pageChanged() {
        this.refreshState();
    }

}

PacijentController.$inject= ['$uibModal', 'Pacijent', '$state'];

export {PacijentController};



// WEBPACK FOOTER //
// ./app/components/pacijent/pacijent.controller.js